import { render } from "./AgentInvitesManagement.vue?vue&type=template&id=22b40944"
import script from "./AgentInvitesManagement.vue?vue&type=script&lang=js"
export * from "./AgentInvitesManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__